
// eventually point to the same domain as GET /objectType/{param}
const baseUrl = 'https://vp73cam335.execute-api.us-east-1.amazonaws.com/v1'

export const getOrg = async (idToken, email) => fetch(`${baseUrl}/org/${email}`, {
  method: 'GET',
  headers: headers(idToken)
})

function headers(idToken) { 
  return {
    idtoken: idToken,
  }
}
